// 渠道类型
export enum ChannelGenres {
    '对外渠道' = 1,
    '销售渠道' = 2
}
// 渠道对接类型
export enum JoinType {
    'API对接'  = 1,
    'H5对接',
    '特殊对接'
}